import script from "./PropertyAssetRegisterTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyAssetRegisterTable.vue?vue&type=script&setup=true&lang=js"

import "./PropertyAssetRegisterTable.vue?vue&type=style&index=0&id=63dfe3f6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63dfe3f6"]])

export default __exports__